/**
 * @desc 已核对信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.ExportDeclarationYHDRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/yhdExportDeclaration`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
